// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import OnBoardingTrial from '../components/OnBoardingTrial';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    initialAuthDone: state.auth.initialAuthDone,
    errorOnboarding: state.onBoarding.errorOnboarding,
    error: state.onBoarding.error,
    currencies: state.currency.currencies,
    countries: state.country.countries,
    isFetchingCountries: state.country.isFetchingCountries,
    isFetchingCurrencies: state.currency.isFetching,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({}, dispatch)
)(OnBoardingTrial);
